import styles from '../../style.module.scss'
import useStore from "../../store/store";
import SummaryLine from "./summary-line";
import formatPrice from "../../utils/format-price";
import SummaryPromoCode from "./summary-promocode";
import SummaryBonus from "./summary-bonus";
import {useEffect, useState} from "react";
import ChevronDownIcon from "../ui/icons/chevron-down-icon";
import {serviceType} from "../../utils/service-type";
import {getFixedLocationServiceTotalPrice, getLocationServiceTotalPrice} from "../../utils/location-service";
import {getServiceName} from "../../utils/service-text";
import {translateRateName} from "../../utils/rate-name";
import SummaryHead from "./summary-head";
import Submit from "../submit/submit";
import ShortVersionSubmitFields from "../submit/short-version-submit-fields";
import formatDate from "../../utils/format-date";
import {
    calcV2RentFromDays,
    fetchCarPricesResponse,
    getPeriodSalePercent,
    getPersonalSalePercent,
} from "../../utils/calendar";

const getOneDayTierPrice = (list) => {
    if (!list?.length) {
        return null;
    }
    const oneDayTier = list.find((item) => parseInt(item.days_min) === 1);
    const tier = oneDayTier || list[0];
    const price = parseInt(tier?.price || 0);
    return price > 0 ? price : null;
};

const Summary = ({rates, car, promoFinishDate, promoPriceGrid, priceGrid, insurances, services, links, version = 1, crmCarId = null}) => {

    const isV2 = Number(version) === 2;
    const currentInsurance = useStore((state) => state.currentInsurance)
    const carDeliveryLocation = useStore((state) => state.carDeliveryLocation)
    const carReturnLocation = useStore((state) => state.carReturnLocation)
    const currentRate = useStore((state) => state.currentRate)
    const startDate = useStore((state) => state.startDate)
    const startHours = useStore((state) => state.startHours)
    const finishDate = useStore((state) => state.finishDate)
    const finishHours = useStore((state) => state.finishHours)
    const carServices = useStore((state) => state.carServices)
    const promoCodeSale = useStore((state) => state.promoCodeSale)
    const isApplyPromoCode = useStore((state) => state.isApplyPromoCode)
    const user = useStore((state) => state.user)
    const bonusPay = useStore((state) => state.bonusPay)
    const rateDayPayMode = priceGrid?.[currentRate]?.length === 1;
    const discountDisable = rates?.find((item) => item.id === currentRate)?.discountDisable === 1;
    const [showCheck, setShowCheck] = useState(false);
    const [v2DaysPrices, setV2DaysPrices] = useState(null);
    const [v2PricesLoading, setV2PricesLoading] = useState(false);
    const lang = useStore((state) => state.lang)
    const shortVersion = useStore((state) => state.shortVersion)
    const surcharge = useStore((state) => state.surcharge)
    const workTime = useStore((state) => state.workTime)
    const devMode = useStore((state) => state.devMode)
    const payMethod = useStore((state) => state.payMethod)
    const setPayMethod = useStore((state) => state.setPayMethod)
    const disableOtherDiscount = useStore((state) => state.disableOtherDiscount)
    const exclusivePromo = disableOtherDiscount && isApplyPromoCode;
    const carId = useStore((state) => state.carId);
    const periodSales = useStore((state) => state.periodSales);
    const setPeriodSales = useStore((state) => state.setPeriodSales);

    const hasCarPromoOffer = () => {
        if (discountDisable) {
            return false;
        }
        if (parseInt(currentRate) !== 1 && parseInt(currentRate) !== 2) {
            return false;
        }
        if (!promoFinishDate || !promoPriceGrid?.length || !startDate) {
            return false;
        }
        const date = new Date(promoFinishDate);
        return date >= startDate;
    };

    const t = {
        tariff: lang === 'en' ? 'Tariff' : 'Тариф',
        deposit: lang === 'en' ? 'Deposit' : 'Залог',
        mileage: lang === 'en' ? 'Mileage' : 'Пробег',
        overMileage: lang === 'en' ? 'Overmileage' : 'Перепробег',
        numberOfDays: lang === 'en' ? 'Number of rental days' : 'Количество суток аренды',
        totalMileage: lang === 'en' ? 'Total mileage for the entire rental period' : 'Общий пробег на весь срок аренды',
        paymentPerKm: lang === 'en' ? 'Payment per km' : 'Оплата за пробег',
        byTariff: lang === 'en' ? 'By tariff' : 'По тарифу',
        rentPerDay: lang === 'en' ? 'Cost per rental day' : 'Стоимость аренды за сутки',
        promoDiscount: lang === 'en' ? 'Promo code discount' : 'Скидка промокод',
        personalDiscount: lang === 'en' ? 'Personal discount' : 'Личная скидка',
        loyaltyDiscount: lang === 'en' ? 'Loyalty program discount' : 'Скидка по программе лояльности',
        periodDiscount: lang === 'en' ? 'Long-term rental discount' : 'Скидка за длительную аренду',
        liabilityReduction: lang === 'en' ? 'Liability reduction package' : 'Пакет снижения ответственности',
        carDelivery: lang === 'en' ? 'Car delivery' : 'Подача авто',
        carReturn: lang === 'en' ? 'Car return' : 'Возврат авто',
        additionalServices: lang === 'en' ? 'Additional services' : 'Дополнительные услуги',
        bonus: lang === 'en' ? 'Bonus' : 'Бонусы',
        superSale: lang === 'en' ? 'Super Sale' : 'Super Sale',
        daySale: lang === 'en' ? 'Sale' : 'Скидка',
        bonusAccrual: lang === 'en' ? 'Bonus accrual' : 'Начисление бонусов',
        total: lang === 'en' ? 'Total:' : 'Итого:',
        costCalculation: lang === 'en' ? 'Cost calculation' : 'Расчет стоимости',
        consent: lang === 'en' ? 'By clicking on the "Submit application" button, you consent to the processing of your personal data.' : ' Нажимая на кнопку "Отправить заявку" Вы соглашаетесь на обработку персональных данных',
        payCash: lang === 'en' ? 'Cash' : 'Наличными',
        paySaving: lang === 'en' ? 'You save' : 'Вы экономите',
        payCard: lang === 'en' ? 'By card or QR code' : 'По карте или QR коду',
        payCardDescription: lang === 'en' ? 'Standard payment price' : 'Стандартная цена при оплате',
        payCaption: lang === 'en' ? 'Payment method is selected upon receiving the car' : 'Способ оплаты выбирается при получении авто',
    };

    useEffect(() => {
        if (!isV2) {
            return undefined;
        }
        if (!startDate || !finishDate || (!carId && !crmCarId)) {
            setV2DaysPrices(null);
            return undefined;
        }

        const ac = new AbortController();
        setV2PricesLoading(true);

        fetchCarPricesResponse({
            id: carId,
            carid: crmCarId || car?.carid,
            dtstart: formatDate(startDate),
            dtend: formatDate(finishDate),
            signal: ac.signal,
        })
            .then((data) => {
                if (!ac.signal.aborted) {
                    setV2DaysPrices(data?.prices?.days || {});
                    if (data?.periodSales) {
                        setPeriodSales(data.periodSales);
                    }
                }
            })
            .catch((error) => {
                if (error?.name === 'AbortError') {
                    return;
                }
                console.error(error.message);
                if (!ac.signal.aborted) {
                    setV2DaysPrices({});
                }
            })
            .finally(() => {
                if (!ac.signal.aborted) {
                    setV2PricesLoading(false);
                }
            });

        return () => {
            ac.abort();
        };
    }, [isV2, startDate, finishDate, carId, crmCarId, car?.carid]);

    const limitKm = () => {
        return rates.find(item => item.id === currentRate)?.limit || null;
    }
    const countDays = () => {
        if (startDate && startHours !== null && finishDate && finishHours !== null) {
            const oneDay = 24 * 60 * 60 * 1000;
            const start = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), startHours, 0, 0);
            const finish = new Date(finishDate.getFullYear(), finishDate.getMonth(), finishDate.getDate(), finishHours - 1, 0, 0);
            return Math.ceil(Math.abs((finish - start) / oneDay));
        }
        return null;
    }

    const getRatePromoCalcData = () => {
        if (!devMode) {
            return null;
        }
        const days = countDays();
        if (!days || !startDate || !priceGrid || !priceGrid[currentRate]) {
            return null;
        }

        let regularDayPrice = null;
        let firstRegularDayPrice = null;

        const baseList = priceGrid[currentRate] || [];
        for (let i = 0; i < baseList.length; i++) {
            const item = baseList[i];
            const itemPrice = parseInt(item?.price || 0);
            if (i === 0 && !firstRegularDayPrice && itemPrice > 0) {
                firstRegularDayPrice = itemPrice;
            }
            if (item.days_min <= days && days <= item.days_max && itemPrice > 0) {
                regularDayPrice = itemPrice;
            }
        }

        if (!regularDayPrice && firstRegularDayPrice) {
            regularDayPrice = firstRegularDayPrice;
        }

        let promoDayPrice = null;
        let promoFinish = null;

        if (
            !discountDisable &&
            (parseInt(currentRate) === 1 || parseInt(currentRate) === 2) &&
            !!promoFinishDate &&
            !!promoPriceGrid &&
            promoPriceGrid.length > 0
        ) {
            promoFinish = new Date(promoFinishDate);
            const promoList = promoPriceGrid || [];
            for (let i = 0; i < promoList.length; i++) {
                const item = promoList[i];
                const itemPrice = parseInt(item?.price || 0);
                if (item.days_min <= days && days <= item.days_max && itemPrice > 0) {
                    promoDayPrice = itemPrice;
                }
            }
        }

        if (!regularDayPrice && !promoDayPrice) {
            return null;
        }

        let promoDays = 0;
        let normalDays = 0;

        if (promoFinish && promoDayPrice) {
            for (let dayIndex = 0; dayIndex < days; dayIndex++) {
                const currentDay = new Date(
                    startDate.getFullYear(),
                    startDate.getMonth(),
                    startDate.getDate() + dayIndex,
                    0,
                    0,
                    0,
                    0
                );
                if (currentDay <= promoFinish) {
                    promoDays++;
                } else {
                    normalDays++;
                }
            }
        } else {
            normalDays = days;
        }

        if (!regularDayPrice && promoDayPrice) {
            regularDayPrice = promoDayPrice;
            promoDays = days;
            normalDays = 0;
        }

        if (promoDays === 0 && normalDays === 0) {
            normalDays = days;
        }

        return {
            days,
            regularDayPrice,
            promoDayPrice,
            promoDays,
            normalDays
        };
    }

    const getListPrices = () => {
        if (exclusivePromo && priceGrid?.[currentRate]) {
            return {list: priceGrid[currentRate], isPromo: false};
        }
        if (!discountDisable && (parseInt(currentRate) === 1 || parseInt(currentRate) === 2) && !!promoFinishDate && !!promoPriceGrid) {
            const date = new Date(promoFinishDate);
            if (date >= startDate) {
                return {list: promoPriceGrid, isPromo: true};
            }
        }
        if (priceGrid[currentRate]) {
            return {list: priceGrid[currentRate], isPromo: false};
        }

        return {list: [], isPromo: false};
    }
    const getRate = () => rates.filter((rate) => parseInt(rate.id) === currentRate)?.[0]
    const getRateDayPrice = () => {
        const days = countDays();

        if (exclusivePromo) {
            return getOneDayTierPrice(priceGrid?.[currentRate] || []);
        }

        if (devMode) {
            const promoData = getRatePromoCalcData();
            if (promoData && (promoData.promoDayPrice || promoData.regularDayPrice)) {
                return promoData.promoDayPrice || promoData.regularDayPrice || null;
            }
        }

        const priceData = getListPrices()?.list?.filter((item) => item.days_min <= days && days <= item.days_max)?.[0]
        if (priceData) {
            return priceData?.price || null;
        }

        return null;
    }
    const getInsuranceDayPrice = () => {
        if (currentInsurance) {
            const insurance = insurances.filter((item) => item.caraddonid === currentInsurance)?.[0];
            if (insurance) {
                return parseInt(insurance?.caraddonprice || 0);
            }
        }
        return 0;
    }
    const getCarDeliveryLocationData = () => {
        if (!carDeliveryLocation || !services?.length) {
            return null;
        }

        const service = services.find((item) => item.caraddonid === carDeliveryLocation);
        if (!service) {
            return null;
        }

        const priceGetter = isV2 ? getFixedLocationServiceTotalPrice : getLocationServiceTotalPrice;
        const price = priceGetter(service, {
            isPickup: true,
            startHours,
            workTime,
        });

        if (!price) {
            return null;
        }

        return {
            label: getServiceName(service, lang) || t.carDelivery,
            price,
        };
    }
    const getCarReturnLocationData = () => {
        if (!carReturnLocation || !services?.length) {
            return null;
        }

        const service = services.find((item) => item.caraddonid === carReturnLocation);
        if (!service) {
            return null;
        }

        const priceGetter = isV2 ? getFixedLocationServiceTotalPrice : getLocationServiceTotalPrice;
        const price = priceGetter(service, {
            isPickup: false,
            finishHours,
            workTime,
        });

        if (!price) {
            return null;
        }

        return {
            label: getServiceName(service, lang) || t.carReturn,
            price,
        };
    }
    const getCarDeliveryLocationPrice = () => getCarDeliveryLocationData()?.price || 0
    const getCarReturnLocationPrice = () => getCarReturnLocationData()?.price || 0

    const getV2PersonalSale = () => {
        if (discountDisable) {
            return {percent: 0, type: null};
        }
        return getPersonalSalePercent(user, promoCodeSale, {exclusivePromo});
    };

    const getV2RentCalc = () => {
        if (!isV2 || !v2DaysPrices) {
            return {
                tariffTotal: 0,
                avgPerDay: 0,
                loyaltyDiscount: 0,
                superSaleDiscount: 0,
                daySaleDiscount: 0,
                periodSaleDiscount: 0,
                periodSalePercent: 0,
                pricedDays: 0,
            };
        }
        const personal = getV2PersonalSale();
        const days = countDays();
        return calcV2RentFromDays(v2DaysPrices, {
            salePercent: personal.percent,
            periodSalePercent: getPeriodSalePercent(periodSales, days),
            daysCount: days,
        });
    };

    const getRateSum = () => {
        if (isV2) {
            return getV2RentCalc().tariffTotal;
        }
        if (exclusivePromo) {
            const dayPrice = getRateDayPrice();
            return dayPrice ? countDays() * dayPrice : 0;
        }
        if (devMode) {
            const promoData = getRatePromoCalcData();
            if (promoData && (promoData.regularDayPrice || promoData.promoDayPrice)) {
                const {regularDayPrice, promoDayPrice, promoDays, normalDays} = promoData;
                const usedPromoPrice = promoDayPrice || regularDayPrice || 0;
                const regular = regularDayPrice || 0;
                const total = (normalDays * regular) + (promoDays * usedPromoPrice);
                return Math.round(total);
            }
        }
        return countDays() * getRateDayPrice();
    }
    const getInsuranceSum = () => {
        return countDays() * getInsuranceDayPrice();
    }
    const getServicesSum = () => {
        let sum = 0;
        if (!!carServices && !!carServices.length) {
            for (let i = 0; i < carServices.length; i++) {
                const serviceId = carServices[i].serviceId;
                const service = services.find((item) => item.caraddonid === serviceId)
                if (!!service) {
                    if (serviceType(service.caraddontype) === 'one_time') {
                        sum += parseInt(service.caraddonprice);
                    }
                    if (serviceType(service.caraddontype) === 'day') {
                        sum += countDays() * parseInt(service.caraddonprice);
                    }
                }
            }
        }
        return sum;
    }
    const getSalePercent = (p = true) => {

        if (!exclusivePromo && !!superSaleSum()) {
            return [0, null];
        }
        if (!discountDisable && !!user && !!user.sale && !!promoCodeSale) {
            if (user.sale > promoCodeSale) {
                return p ? user.sale : [user.sale, 'card'];
            } else {
                return p ? promoCodeSale : [promoCodeSale, 'promo'];
            }
        } else {
            if (!!user && !!user.sale) {
                return p ? user.sale : [user.sale, 'card'];
            } else {
                if (!!promoCodeSale) {
                    return p ? promoCodeSale : [promoCodeSale, 'promo'];
                }
            }
        }
        return p ? 0 : [0, null];
    }
    const getRentSumAfterSale = () => {
        if (isV2) {
            return getV2RentCalc().tariffTotal;
        }
        let rentSum = getRateSum();
        if (!discountDisable && rentSum > 1 && getSalePercent() > 0) {
            rentSum = rentSum * (100 - getSalePercent()) / 100;
        }
        return Math.round(rentSum);
    }
    const getMaxBonusForRent = () => {
        const rentSum = getRentSumAfterSale();
        if (rentSum < 1) {
            return 0;
        }
        return Math.floor(rentSum * 50 / 100);
    }
    const getBonusDeduction = () => {
        if (discountDisable || exclusivePromo || !user?.bonus || !bonusPay) {
            return 0;
        }
        return Math.min(user.bonus, getMaxBonusForRent());
    }
    const getSum = (includeSurchargeSum = false) => {
        if (isV2) {
            if (v2DaysPrices == null || v2PricesLoading) {
                return 0;
            }
            let sum = getV2RentCalc().tariffTotal;
            if (!discountDisable && bonusPay) {
                sum -= getBonusDeduction();
            }
            sum += getInsuranceSum();
            sum += getCarDeliveryLocationPrice();
            sum += getCarReturnLocationPrice();
            sum += getServicesSum();
            if (includeSurchargeSum && payMethod === 'qr') {
                sum += surchargeSum();
            }
            if (sum < 1) {
                return 0;
            }
            return Math.round(sum);
        }

        if (exclusivePromo) {
            let rentSum = getRateSum();
            const salePercent = getSalePercent();
            if (rentSum > 1 && salePercent > 0) {
                rentSum = rentSum * (100 - salePercent) / 100;
            }
            let sum = rentSum;
            sum += getInsuranceSum();
            sum += getCarDeliveryLocationPrice();
            sum += getCarReturnLocationPrice();
            sum += getServicesSum();
            if (includeSurchargeSum && payMethod === 'qr') {
                sum += surchargeSum();
            }
            if (sum < 1) {
                sum = 1;
            }
            return Math.round(sum);
        }

        let sum = 0;
        sum += getRateSum();

        if (!discountDisable && sum > 1 && getSalePercent() > 0) {
            sum = sum * (100 - getSalePercent()) / 100;
        }

        if (!discountDisable && bonusPay) {
            sum -= getBonusDeduction();
        }
        sum += getInsuranceSum();
        sum += getCarDeliveryLocationPrice();
        sum += getCarReturnLocationPrice();
        sum += getServicesSum();
        if (includeSurchargeSum && payMethod === 'qr') {
            sum += surchargeSum();
        }
        if (sum < 1) {
            sum = 1;
        }

        return Math.round(sum);
    }
    const cashBackSum = (percent = 0) => {
        if (isV2) {
            if (percent > 0) {
                const sum = getV2RentCalc().tariffTotal * percent / 100;
                if (sum >= 1) {
                    return Math.floor(sum);
                }
            }
            return 0;
        }
        if (!discountDisable && percent > 0) {
            let sum = getRateSum();
            if (sum > 1 && getSalePercent() > 0) {
                sum = sum * (100 - getSalePercent()) / 100;
            }
            sum = sum * percent / 100;
            if (sum >= 1) {
                return Math.floor(sum)
            }
        }
        return 0;
    }

    const superSaleSum = () => {
        if (devMode) {
            const promoData = getRatePromoCalcData();
            if (!promoData || discountDisable) {
                return 0;
            }
            const {days, regularDayPrice, promoDayPrice, promoDays} = promoData;
            if (!promoDayPrice || !regularDayPrice || !promoDays || !days) {
                return 0;
            }
            const totalDiscount = (regularDayPrice - promoDayPrice) * promoDays;
            if (totalDiscount <= 0) {
                return 0;
            }
            return totalDiscount / days;
        }

        const {isPromo} = getListPrices();
        if (!discountDisable && isPromo) {
            const days = countDays();
            const priceData1 = priceGrid[currentRate]?.filter((item) => item.days_min <= days && days <= item.days_max)?.[0]
            const priceData2 = getListPrices()?.list?.filter((item) => item.days_min <= days && days <= item.days_max)?.[0]
            if (priceData1?.price && priceData2?.price) {
                return parseInt(priceData1.price - priceData2.price);
            }
        }

        return 0;
    }

    const surchargeSum = () => {
        const sum = getSum();
        if (!!surcharge && surcharge > 0) {
            const surchargeSum = (sum / 100) * (100 + surcharge);
            return Math.abs(Math.round(surchargeSum - sum));
        }
        return 0;
    }
    if (!currentRate || !car || !priceGrid) {
        return null;
    }

    const carDeliveryLocationData = getCarDeliveryLocationData();
    const carReturnLocationData = getCarReturnLocationData();
    const v2Rent = isV2 ? getV2RentCalc() : null;
    const v2PersonalSale = isV2 ? getV2PersonalSale() : {percent: 0, type: null};
    const v2LoyaltyDiscount = isV2 ? (v2Rent?.loyaltyDiscount || 0) : 0;
    const v2SuperSaleDiscount = isV2 ? (v2Rent?.superSaleDiscount || 0) : 0;
    const v2DaySaleDiscount = isV2 ? (v2Rent?.daySaleDiscount || 0) : 0;
    const v2PeriodSaleDiscount = isV2 ? (v2Rent?.periodSaleDiscount || 0) : 0;
    const v2PricesReady = !isV2 || (v2DaysPrices != null && !v2PricesLoading);
    const totalSum = getSum(true);
    const totalSumLabel = v2PricesReady ? formatPrice(totalSum) : '';

    return (
        <div className={styles.summary} data-summary-version={version}>
            <SummaryHead/>
            <div className={styles.body}>

                {!isV2 && (
                    <SummaryLine label={t.tariff} value={translateRateName(getRate()?.name, lang)}/>
                )}
                {
                    !shortVersion && !!car.carzalog && (
                        <SummaryLine label={t.deposit} value={`от ${formatPrice(car.carzalog)}`}/>)
                }

                {
                    !rateDayPayMode && (
                        <>
                            {
                                !!limitKm() && (<SummaryLine label={t.mileage}
                                                             value={`${limitKm()} ${lang === 'en' ? 'km' : 'км'} / ${lang === 'en' ? 'day' : 'сут'}`}/>)
                            }
                            {
                                !!car.carkmprice && (
                                    <SummaryLine label={t.overMileage}
                                                 value={`${formatPrice(car.carkmprice)} /${lang === 'en' ? 'km' : 'км'}`}/>)
                            }
                            {
                                !!countDays() && (<SummaryLine label={t.numberOfDays} value={`${countDays()}`}/>)
                            }
                            {
                                !!limitKm() && countDays() > 1 && (<SummaryLine label={t.totalMileage}
                                                                                value={`${limitKm() * countDays()} ${lang === 'en' ? 'km' : 'км'}`}/>)
                            }
                        </>
                    )
                }
                {
                    rateDayPayMode && (
                        <>
                            {
                                !!car.carkmprice && rateDayPayMode && (
                                    <SummaryLine label={t.paymentPerKm}
                                                 value={`${formatPrice(car.carkmprice)} / ${lang === 'en' ? 'km' : 'км'}`}/>)
                            }
                            {
                                !!countDays() && (<SummaryLine label={t.numberOfDays} value={`${countDays()}`}/>)
                            }
                        </>
                    )
                }
                {
                    !discountDisable && !hasCarPromoOffer() && (<SummaryPromoCode car={car}/>)
                }
                {
                    !discountDisable && !exclusivePromo && (<SummaryBonus/>)
                }
                <div className={styles.hr}/>
                <div className={styles.check}>
                    <div className={`${styles.showButton} ${showCheck && styles.active} p-extra-small-size`}
                         onClick={() => setShowCheck(!showCheck)}>
                        {t.costCalculation}
                        <ChevronDownIcon/>
                    </div>
                    {
                        showCheck && (
                            <div className={styles.showList}>
                                {isV2 ? (
                                    <>
                                        {!!countDays() && !!v2Rent?.avgPerDay && (
                                            <SummaryLine
                                                label={t.rentPerDay}
                                                value={v2PricesLoading ? '...' : formatPrice(v2Rent.avgPerDay)}
                                            />
                                        )}
                                        {!!getInsuranceSum() && (
                                            <SummaryLine label={t.liabilityReduction}
                                                         value={formatPrice(getInsuranceSum())}/>
                                        )}
                                        {!!getServicesSum() && (
                                            <SummaryLine label={t.additionalServices}
                                                         value={formatPrice(getServicesSum())}/>
                                        )}
                                        {!!carDeliveryLocationData && (
                                            <SummaryLine label={carDeliveryLocationData.label}
                                                         value={formatPrice(carDeliveryLocationData.price)}/>
                                        )}
                                        {!!carReturnLocationData && (
                                            <SummaryLine label={carReturnLocationData.label}
                                                         value={formatPrice(carReturnLocationData.price)}/>
                                        )}
                                        {v2SuperSaleDiscount > 0 && (
                                            <SummaryLine label={t.superSale}
                                                         value={`-${formatPrice(v2SuperSaleDiscount)}`}/>
                                        )}
                                        {v2DaySaleDiscount > 0 && (
                                            <SummaryLine label={t.daySale}
                                                         value={`-${formatPrice(v2DaySaleDiscount)}`}/>
                                        )}
                                        {v2PeriodSaleDiscount > 0 && (
                                            <SummaryLine
                                                label={`${t.periodDiscount}${v2Rent?.periodSalePercent ? ` −${v2Rent.periodSalePercent}%` : ''}`}
                                                value={`-${formatPrice(v2PeriodSaleDiscount)}`}
                                            />
                                        )}
                                        {v2LoyaltyDiscount > 0 && (
                                            <SummaryLine
                                                label={v2PersonalSale.type === 'promo' ? t.promoDiscount : t.loyaltyDiscount}
                                                value={`-${formatPrice(v2LoyaltyDiscount)}`}
                                            />
                                        )}
                                        {!exclusivePromo && getBonusDeduction() > 0 && (
                                            <SummaryLine label={t.bonus}
                                                         value={`-${formatPrice(getBonusDeduction())}`}/>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        <SummaryLine label={t.byTariff}
                                                     value={formatPrice(getRateSum() + (exclusivePromo ? 0 : superSaleSum() * countDays()))}/>
                                        {
                                            !!getSalePercent() && getSalePercent(false)[1] === 'promo' && (
                                                <SummaryLine label={t.promoDiscount} value={`-${getSalePercent()}%`}/>
                                            )
                                        }
                                        {
                                            !!getSalePercent() && getSalePercent(false)[1] === 'card' && (
                                                <SummaryLine label={t.personalDiscount} value={`-${getSalePercent()}%`}/>
                                            )
                                        }
                                        {
                                            !!getInsuranceSum() && (<SummaryLine label={t.liabilityReduction}
                                                                                 value={formatPrice(getInsuranceSum())}/>)
                                        }
                                        {
                                            !!carDeliveryLocationData && (
                                                <SummaryLine label={carDeliveryLocationData.label}
                                                             value={formatPrice(carDeliveryLocationData.price)}/>)
                                        }
                                        {
                                            !!carReturnLocationData && (
                                                <SummaryLine label={carReturnLocationData.label}
                                                             value={formatPrice(carReturnLocationData.price)}/>)
                                        }
                                        {
                                            !!getServicesSum() && (
                                                <SummaryLine label={t.additionalServices} value={formatPrice(getServicesSum())}/>)
                                        }
                                        {
                                            !exclusivePromo && getBonusDeduction() > 0 && (
                                                <SummaryLine label={t.bonus} value={`-${formatPrice(getBonusDeduction())}`}/>
                                            )
                                        }
                                        {
                                            !exclusivePromo && !!superSaleSum() && (
                                                <SummaryLine label={t.superSale}
                                                             value={`-${formatPrice(superSaleSum() * countDays())}`}/>
                                            )
                                        }
                                    </>
                                )}
                            </div>
                        )
                    }

                </div>

                <div className={styles.hr}/>
                {
                    !!user?.cashback && (
                        <>
                            <div className={styles.cashback}>
                                <div className={`p-extra-small-size`}>{t.bonusAccrual}</div>
                                <div className={`p-small-size`}>+{formatPrice(cashBackSum(parseInt(user.cashback)))}</div>
                            </div>
                            <div className={styles.hr}/>
                        </>
                    )
                }
                {!!totalSumLabel && (
                    <div className={`${styles.sum} h2-size`}>{t.total} {totalSumLabel}</div>
                )}
                {
                    !!shortVersion && (<ShortVersionSubmitFields/>)
                }

                {
                    !shortVersion && !!surcharge && surcharge > 0 && surchargeSum() > 0 && (
                        <div className={styles.payMethods}>
                            <button className={`${styles.payMethod} ${payMethod === 'cash' ? styles.checked : ''}`}
                                    onClick={() => setPayMethod('cash')}>
                                <div className={styles.payCheckbox}></div>
                                <div className={styles.payName}>{t.payCash} (-{surcharge}%)</div>
                                <div className={styles.payDescription}>{t.paySaving} {formatPrice(surchargeSum())}</div>

                            </button>
                            <button className={`${styles.payMethod} ${payMethod === 'qr' ? styles.checked : ''}`}
                                    onClick={() => setPayMethod('qr')}>
                                <div className={styles.payCheckbox}></div>
                                <div className={styles.payName}>
                                    <div>{t.payCard}</div>
                                    <div>+{formatPrice(surchargeSum())}</div>
                                </div>
                                <div className={styles.payDescription}>{t.payCardDescription}</div>

                            </button>
                            <div className={styles.payCaption}>{t.payCaption}</div>
                        </div>
                    )
                }
                <Submit
                    countDays={countDays()}
                    rateSum={getRateSum()}
                    sale={isV2
                        ? [v2PersonalSale.percent || 0, v2PersonalSale.type]
                        : getSalePercent(false)}
                    rate={getRate()}
                    surchargeSum={getSum(true)}
                    version={version}
                    avgPerDay={isV2 ? (v2Rent?.avgPerDay || 0) : 0}
                    rentGross={isV2 ? (v2Rent?.rentGross || 0) : 0}
                    loyaltyDiscount={isV2 && v2PersonalSale.type === 'card' ? v2LoyaltyDiscount : 0}
                    promoDiscount={isV2 && v2PersonalSale.type === 'promo' ? v2LoyaltyDiscount : 0}
                    superSaleDiscount={isV2 ? v2SuperSaleDiscount : 0}
                    daySaleDiscount={isV2 ? v2DaySaleDiscount : 0}
                    periodSaleDiscount={isV2 ? v2PeriodSaleDiscount : 0}
                    periodSalePercent={isV2 ? (v2Rent?.periodSalePercent || 0) : 0}
                    bonusSum={isV2 ? getBonusDeduction() : 0}
                    insuranceSum={isV2 ? getInsuranceSum() : 0}
                    servicesSum={isV2 ? getServicesSum() : 0}
                    deliverySum={isV2 ? (carDeliveryLocationData?.price || 0) : 0}
                    returnSum={isV2 ? (carReturnLocationData?.price || 0) : 0}
                    deliveryLocationId={isV2 ? (carDeliveryLocationData ? carDeliveryLocation : null) : undefined}
                    returnLocationId={isV2 ? (carReturnLocationData ? carReturnLocation : null) : undefined}
                    pricesReady={v2PricesReady}
                />
                {
                    !!links && (<div className={styles.links}>
                        {!!links.tel && (
                            <a href={links.tel.link} target='_blank' rel='noreferrer'
                               className={`${styles.link} ${styles.tel}`}>
                                <img src={links.tel.icon} width={24} height={24} alt='tel icon'/>
                            </a>)}
                        {!!links.whatsapp && (
                            <a href={links.whatsapp.link} target='_blank' rel='noreferrer'
                               className={`${styles.link} ${styles.whatsapp}`}>
                                <img src={links.whatsapp.icon} width={24} height={24} alt='whatsapp icon'/>
                            </a>)}
                        {!!links.telegram && (
                            <a href={links.telegram.link} target='_blank' rel='noreferrer'
                               className={`${styles.link} ${styles.telegram}`}>
                                <img src={links.telegram.icon} width={24} height={24} alt='telegram icon'/>
                            </a>)}
                    </div>)
                }
                <div className={`${styles.description} p-extra-small-size `}>
                    {t.consent}
                </div>
            </div>
        </div>
    );
};

export default Summary;